import { environment } from 'src/environments/environment';

function dashboardPath(suffix: string): string {
  const env = environment as { urlPath?: string };
  const base = String(env.urlPath || '/').replace(/\/?$/, '/');
  return `${base}${String(suffix || '').replace(/^\//, '')}`;
}

export async function createHostedEmailPreviewUrl(html: string): Promise<string> {
  const res = await fetch(dashboardPath('channel-email-preview'), {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ html }),
  });
  if (!res.ok) {
    throw new Error('preview-unavailable');
  }
  const data = await res.json();
  const id = String(data?.id || '').trim();
  if (!id) {
    throw new Error('preview-unavailable');
  }
  return dashboardPath(`channel-email-preview/${id}`);
}
